const config = {
    BASE_URL: "https://shreelalchand.com/logistics"
}

export default config;